import { useState } from "react";
import AnnouncementBar from "@/components/landing/AnnouncementBar";
import Navbar from "@/components/landing/Navbar";
import Footer from "@/components/landing/Footer";
import WhatsAppFloat from "@/components/landing/WhatsAppFloat";
import LeadDialog from "@/components/landing/LeadDialog";

/**
 * Shared shell with pinned AnnouncementBar + Navbar, Footer, floating WhatsApp,
 * and a lead-capture dialog. Pass children as the page body.
 */
export default function PageLayout({ children, testId = "page-root" }) {
  const [leadOpen, setLeadOpen] = useState(false);
  const [leadCtx, setLeadCtx] = useState({ plan: "", title: "Get Started with Markite" });

  const openLead = (plan = "", title = "Get Started with Markite") => {
    setLeadCtx({ plan, title });
    setLeadOpen(true);
  };

  return (
    <div className="relative min-h-screen overflow-x-hidden bg-slate-950 text-slate-100" data-testid={testId}>
      <div className="fixed inset-x-0 top-0 z-50">
        <AnnouncementBar onClick={() => openLead("", "Claim the offer")} />
        <Navbar onCTA={() => openLead("", "Get Started with Markite")} />
      </div>
      <div aria-hidden className="h-[106px]" />

      <main>
        {typeof children === "function" ? children({ openLead }) : children}
      </main>

      <Footer />
      <WhatsAppFloat />
      <LeadDialog
        open={leadOpen}
        onOpenChange={setLeadOpen}
        plan={leadCtx.plan}
        title={leadCtx.title}
        showOffer={!["Advanced", "Pro"].includes(leadCtx.plan)}
      />
    </div>
  );
}
